var exports = {
  "kL": "SegmentedTabs.module__container___S09jYW",
  "gj": "SegmentedTabs.module__tabList___S09jYW",
  "Mf": "SegmentedTabs.module__tab___S09jYW",
  "DF": "SegmentedTabs.module__tabInactive___S09jYW",
  "yR": "SegmentedTabs.module__tabActive___S09jYW",
  "KE": "SegmentedTabs.module__tabBackground___S09jYW",
};

module.exports = exports;
